'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./es/react-hotkeys.production.min.js');
} else {
  module.exports = require('./es/index.js');
}



//////////////////
// WEBPACK FOOTER
// ../player-search-module/node_modules/@csod/predictive-search/node_modules/react-hotkeys/index.es.js
// module id = 571
// module chunks = 0